import { addSideEffects } from '@poa/state';
import { createUser, fetchUser, updateUser } from './users.actions';

// fetch
addSideEffects(fetchUser, async (payload, { actions, env, store }) => {
  try {
    let response;

    switch (payload.variant) {
      case 'staff':
        response = await env.api.staff
          .fetchStaffById(payload.id)
          .then(user => ({ ...user, password: '', confirm: '' }));
        break;
      default:
        response = await env.api.users.fetchUser(payload.id);
        break;
    }

    actions.usersActions.fetchUserSuccess(response);
  } catch (e) {
    console.error(e);
    actions.usersActions.fetchUserFailed(e);
    // env.alert('Ошибка', `Мы не смогли отктрыть id=${payload.id}`, 'error');
    throw e;
  }
});

// create
addSideEffects(createUser, async (payload, { actions, env, store }) => {
  try {
    if (!payload.user.password || !payload.user.confirm) {
      delete payload.user.password;
      delete payload.user.confirm;
    }

    await env.api.staff.createStaff(payload.user);
    actions.usersActions.createUserSuccess(payload.user);
  } catch (e) {
    console.error(e);
    actions.usersActions.createUserFailed(e);
    env.alert('Ошибка', `Мы не смогли создать персонал`, 'error');
    throw e;
  }
});

// create
addSideEffects(updateUser, async (payload, { actions, env, store }) => {
  try {
    switch (payload.variant) {
      case 'staff':
        if (!payload.user.password || !payload.user.confirm) {
          delete payload.user.password;
          delete payload.user.confirm;
        }

        await env.api.staff.updateStaff(payload.user);
        break;
      default:
        await env.api.users.updateUser(payload.user);
        break;
    }

    actions.usersActions.updateUserSuccess(payload.user);
  } catch (e) {
    console.error(e);
    actions.usersActions.updateUserFailed(e);

    try {
      env.alert('Ошибка', e.response.data.error_message, 'error');
    } catch {
      env.alert('Ошибка', `Мы не смогли сохранить id=${payload.user.id}`, 'error');
    }
    throw e;
  }
});
